import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import { type DashboardData } from '@/types';
import { type DashboardInitialState } from './types';

const initialState: DashboardInitialState = {
  dashboardData: null,
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setDashboardData: (state, { payload }: PayloadAction<DashboardData>) => {
      state.dashboardData = payload;
    },
  },
});

export const { reducer: dashboardReducer } = dashboardSlice;
